export const updateCallToAttentionService =
  (fetch) =>
  async ({ id, formData }) => {
    try {
      const response = await fetch({
        url: `/api/v1/llamados-atencion/${id}`,
        method: "put",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
